export function UsageStats({ org }) {
  if (!org) return null;
  return (
    <div className="mb-8 grid grid-cols-3 gap-4 max-w-lg">
      <div className="border border-white/10 rounded-lg p-4">
        <div className="font-mono text-xs uppercase tracking-wider text-zinc-500">Machines</div>
        <div className="font-heading text-xl font-bold mt-1">{org.usage.machines}<span className="text-zinc-600 text-sm"> / {org.limits.max_machines}</span></div>
      </div>
      <div className="border border-white/10 rounded-lg p-4">
        <div className="font-mono text-xs uppercase tracking-wider text-zinc-500">Members</div>
        <div className="font-heading text-xl font-bold mt-1">{org.usage.members}<span className="text-zinc-600 text-sm"> / {org.limits.max_members}</span></div>
      </div>
      <div className="border border-white/10 rounded-lg p-4">
        <div className="font-mono text-xs uppercase tracking-wider text-zinc-500">Sessions</div>
        <div className="font-heading text-xl font-bold mt-1">{org.limits.max_concurrent}</div>
      </div>
    </div>
  );
}
